// extracted by mini-css-extract-plugin
export var dropdownContainer = "_l2-0";
export var leftAlign = "_l2-4";
export var listItem = "_l2-2";
export var listItemWrapper = "_l2-1";
export var operationText = "_l2-3";